import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createBriefTerm() {
  yield takeEvery(actions.CREATE_BRIEF_TERM, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/briefTerm`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_BRIEF_TERM_ENDED });
    }
  });
}

function* searchBriefTerm() {
  yield takeEvery(actions.SEARCH_BRIEF_TERMS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/briefTerm?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_BRIEF_TERMS_ENDED });
    }
  });
}

function* deleteBriefTerm() {
  yield takeEvery(actions.DELETE_BRIEF_TERM, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/briefTerm`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_BRIEF_TERM_ENDED });
    }
  });
}

function* createBriefTermContent() {
  yield takeEvery(actions.CREATE_BRIEF_TERM_CONTENT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/briefTerm/content`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_BRIEF_TERM_CONTENT_ENDED });
    }
  });
}

function* searchBriefTermContents() {
  yield takeEvery(actions.SEARCH_BRIEF_TERM_CONTENTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/briefTerm/content?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_BRIEF_TERM_CONTENTS_ENDED });
    }
  });
}

function* findBriefTermContent() {
  yield takeEvery(actions.FIND_BRIEF_TERM_CONTENT, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/briefTerm/content/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_BRIEF_TERM_CONTENT_ENDED });
    }
  });
}

function* updateBriefTermContent() {
  yield takeEvery(actions.UPDATE_BRIEF_TERM_CONTENT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/briefTerm/content`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_BRIEF_TERM_CONTENT_ENDED });
    }
  });
}

function* deleteBriefTermContents() {
  yield takeEvery(actions.DELETE_BRIEF_TERM_CONTENTS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/briefTerm/content`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_BRIEF_TERM_CONTENTS_ENDED });
    }
  });
}

function* fetchBriefTermTypes() {
  yield takeEvery(actions.FETCH_BRIEF_TERM_TYPES, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/briefTerm/types`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FETCH_BRIEF_TERM_TYPES_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createBriefTerm),
    fork(searchBriefTerm),
    fork(deleteBriefTerm),

    fork(createBriefTermContent),
    fork(searchBriefTermContents),
    fork(findBriefTermContent),
    fork(updateBriefTermContent),
    fork(deleteBriefTermContents),

    fork(fetchBriefTermTypes),
  ]);
}
